// extracted by mini-css-extract-plugin
export default {"confirmModalBody":"confirmModalBody-HA8nyW"};